<script setup>
import { XCircleIcon } from "@heroicons/vue/20/solid";
import { useI18n } from "vue-i18n";
import { getCurrentInstance } from "vue";

defineProps({ issues: Array });

const { t: __ } = useI18n();
</script>

<template>
    <template v-for="(issue, index) in issues" :key="index">
        <div class="p-4 bg-red-50">
            <div class="flex">
                <div class="flex-shrink-0">
                    <XCircleIcon class="w-5 h-5 text-red-400" aria-hidden="true" />
                </div>
                <div class="ml-3 text-sm text-red-700">
                    <div v-if="issue.key === 'not_started_publications'" class="space-y-3">
                        <div>
                            {{ __("Vous avez des publications non démarrées depuis plus de 5 minutes. Il peut s'agir d'un problème de tâche CRON WordPress.") }}
                        </div>
                        <div class="space-y-2">
                            <div class="text-sm">{{ __("Étapes de vérification :") }}</div>
                            <ol class="space-y-1 text-sm list-inside list-decimal">
                                <li
                                    v-html="
                                        __('Installez le plugin {startlink}WP Crontrol{endlink}.', {
                                            startlink:
                                                '<a href=\'https://wordpress.org/plugins/wp-crontrol/\' target=\'_blank\' class=\'font-bold text-red-900 hover:underline\'>',
                                            endlink: '</a>',
                                        })
                                    "></li>
                                <li>
                                    {{ __("Rendez-vous sur la page") }}
                                    <a
                                        class="font-bold text-red-900 hover:underline"
                                        :href="getCurrentInstance().appContext.config.globalProperties.$admin('tools.php?page=wp-crontrol')"
                                        target="_blank"
                                        >{{ __("Outils / Événements Cron") }}.</a
                                    >
                                </li>
                                <li>
                                    {{ __("Vérifiez que la tâche 'action_scheduler_run_queue' est bien présente et n'est pas en erreur.") }}
                                </li>
                                <li>
                                    {{ __("Rendez-vous sur la page") }}
                                    <a
                                        class="font-bold text-red-900 hover:underline"
                                        :href="getCurrentInstance().appContext.config.globalProperties.$admin('tools.php?page=action-scheduler')"
                                        target="_blank"
                                        >{{ __("Outils / Scheduled Actions") }}.</a
                                    >
                                </li>
                                <li>
                                    {{
                                        __(
                                            "Si une alerte indique qu'une migration est en cours, attendez que la migration soit terminée ou forcez la migration en cliquant sur le bouton 'RUN' de la tâche correspondante dans l'onglet 'Pending'."
                                        )
                                    }}
                                </li>
                                <li>
                                    {{ __("Vérifiez s'il y a des tâches récentes échouées dans l'onglet 'Failed'.") }}
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div v-else-if="issue.key === 'openai_signature'">
                        <div>{{ __("Votre clé API OpenAI ne peut pas être activée. otomatic.ai n'autorise qu'une seule clé API par compte.") }}</div>
                    </div>
                    <div v-else-if="issue.key === 'database'" class="space-y-3">
                        <div>{{ __("Les tables suivantes sont manquantes dans votre base de données :") }}</div>
                        <div class="space-y-2">
                            <ul class="space-y-1 list-inside list-disc">
                                <li v-for="table in issue.missing_tables" :key="table">
                                    {{ table }}
                                </li>
                            </ul>
                        </div>
                        <div class="space-y-2">
                            <div
                                class="text-sm"
                                v-html="
                                    __('Cliquez {startlink}ici{endlink} pour relancer une installation des tables de la base de données.', {
                                        startlink: '<a href=\'' + issue.repair_link + '\' target=\'_blank\' class=\'font-bold text-red-900 hover:underline\'>',
                                        endlink: '</a>',
                                    })
                                "></div>
                        </div>
                    </div>
                    <div v-else>
                        {{ issue.error }}
                    </div>
                </div>
            </div>
        </div>
    </template>
</template>
